import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import FieldItem from './FieldItem';

interface CertificationsSectionProps {
  isEditing: boolean;
  profileData: any;
  onEditField: (field: string) => void;
}

const CertificationsSection: React.FC<CertificationsSectionProps> = ({
  isEditing,
  profileData,
  onEditField,
}) => {
  return (
    <View style={localStyles.sectionCard}>
      <Text style={localStyles.sectionTitle}>Certifications</Text>
      <View style={localStyles.infoGrid}>
        <FieldItem
          label="Certifications"
          value={Array.isArray(profileData.certifications) ? profileData.certifications.join(', ') : (profileData.certifications || '')}
          iconName="certificate"
          isEditing={isEditing}
          onPress={() => onEditField('certifications')}
        />
      </View>
    </View>
  );
};

export default CertificationsSection;

const localStyles = StyleSheet.create({
  sectionCard: {
    backgroundColor: '#FFFFFF',
    borderRadius: 28,
    padding: 24,
    marginBottom: 24,
    borderWidth: 1,
    borderColor: '#F1F5F9',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.03,
    shadowRadius: 10,
    elevation: 3,
  },
  sectionTitle: {
    fontSize: 20,
    fontWeight: '800',
    color: '#1E293B',
    marginBottom: 20,
    letterSpacing: -0.5,
  },
  infoGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    gap: 12,
  },
});


